import Calendar from 'antd-mobile/lib/calendar';
export default Calendar;



// WEBPACK FOOTER //
// ./components/calendar/index.tsx